import { useMutation } from '@apollo/client'
import { SET_APPROVE_STATUS } from './operations'

type Input = {
  userID: string
  isApproved: boolean
}

type Props = {
  onCompleted: (data: boolean) => void
}

export const useSetApproveStatus = ({ onCompleted }: Props) =>
  useMutation<boolean, Input>(SET_APPROVE_STATUS, {
    onCompleted,
  })
